import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Cookies from "js-cookie";  
import Pagination from "../components/Pagination";
import ModalEditarAlarma from "./ModalEditarAlarma";

function ListaAlarmas() {
  const [alarmas, setAlarmas] = useState([]);
  const [alarmaEditando, setAlarmaEditando] = useState(null);
  const [modalAbierto, setModalAbierto] = useState(false);

  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  // Cargar alarmas de la API
  const obtenerAlarmas = useCallback((url = `${API_URL}/api/alarmas/?page_size=5`) => {
    axios.get(url)
      .then(response => {
        if (Array.isArray(response.data)) {
          setAlarmas(response.data); 
        } else if (response.data.results) {
          setAlarmas(response.data.results);
          setNextPage(response.data.next);
          setPrevPage(response.data.previous);
        } else {
          setAlarmas([]);
        }
      })
      .catch(error => {
        console.error("Error al obtener las alarmas:", error);
        setAlarmas([]);
      });
  }, [API_URL]);

  useEffect(() => {
    obtenerAlarmas();
  }, [obtenerAlarmas]);

  // Búsqueda
  const buscarAlarmas = () => {
    obtenerAlarmas(`${API_URL}/api/alarmas/?search=${searchTerm}`);
  };

  // Se llama al pulsar "Editar" en la tabla
  const editarAlarma = (alarma) => {
    setAlarmaEditando(alarma);
    setModalAbierto(true);
  };

  // Al guardar cambios en el modal
  const onAlarmaActualizada = (alarmaActualizada) => {
    setAlarmas(alarmas.map(a => a.id === alarmaActualizada.id ? alarmaActualizada : a));
    setAlarmaEditando(null);
    setModalAbierto(false);
  };

  // Para cerrar el modal sin cambios
  const onCerrarModal = () => {
    setModalAbierto(false);
    setAlarmaEditando(null);
  };

  return (
    <div>
      <h3>Lista de Alarmas</h3>
      <div className="contenedor">
        {/* Búsqueda */}
        <div className="input-group mb-3 mt-3">
          <input
            type="text"
            className="form-control"
            placeholder="Buscar alarma..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className="btn btn-primary" onClick={buscarAlarmas}>
            Buscar
          </button>
        </div>

        {/* Tabla de Alarmas */}
        <table className="table table-striped mt-3">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Mensaje TTS</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {alarmas && alarmas.length > 0 ? (
              alarmas.map((alarma) => (
                <tr key={alarma.id}>
                  <td>{alarma.nombre}</td>
                  <td>{alarma.descripcion}</td>
                  <td>{alarma.mensaje_tts}</td>
                  <td>
                    <button
                      className="btn btn-warning"
                      onClick={() => editarAlarma(alarma)}
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No hay alarmas disponibles.</td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Paginación */}
        <Pagination 
          prevPage={prevPage} 
          nextPage={nextPage} 
          fetchPage={obtenerAlarmas} 
        />
      </div>

      {/* Modal Emergete para Editar */}
      {modalAbierto && (
        <ModalEditarAlarma
          alarmaEditando={alarmaEditando}
          onAlarmaActualizada={onAlarmaActualizada}
          onCerrarModal={onCerrarModal}
        />
      )}
    </div>
  );
}

export default ListaAlarmas;
